import { Outlet } from '@buzola/router'
import { EnvironmentExtensionProvider } from '@contember/react-binding'
import { ContemberClient } from '@contember/react-client'
import { IdentityEnvironmentProvider, IdentityProvider, projectEnvironmentExtension } from '@contember/react-identity'
import { SlotsProvider } from '@contember/react-slots'
import { getConfig } from '~/app/config'

const config = getConfig()

export default function AppLayout() {
	return (
		<SlotsProvider>
			<ContemberClient
				apiBaseUrl={config.apiBaseUrl}
				sessionToken={config.sessionToken}
				project={config.project}
				stage={config.stage}
			>
				<EnvironmentExtensionProvider extension={projectEnvironmentExtension} state={config.project ?? null}>
					<IdentityProvider>
						<IdentityEnvironmentProvider>
							<Outlet />
						</IdentityEnvironmentProvider>
					</IdentityProvider>
				</EnvironmentExtensionProvider>
			</ContemberClient>
		</SlotsProvider>
	)
}
